import { FC } from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";

import FailedJobNotification from "@/components/Notifications/FailedJobNotification";
import useFailedJobsNotifications from "@/hooks/optimisation/useFailedJobsNotifications";

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
`;

interface Props {
  projectsIds: string;
}

const OptimisationOverviewNotifications: FC<Props> = ({ projectsIds }) => {
  const { teamId } = useParams();

  const { notifications, queryKey } = useFailedJobsNotifications(
    projectsIds,
    !!projectsIds
  );

  if (!notifications?.length) {
    return null;
  }

  return (
    <Wrap>
      {notifications.map((notification) => (
        <FailedJobNotification
          queryKey={queryKey}
          notification={notification}
          linkPath={`/teams/${teamId}/optimisation-projects/${notification.notifiableId}`}
          linkText="Go to Project"
          key={notification.id}
        />
      ))}
    </Wrap>
  );
};

export default OptimisationOverviewNotifications;
